/**
 * @generated SignedSource<<c687c4526492229693e69bf51bc51ed2>>
 * @relayHash 39acb1147d229935866fe5c76d20c1bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e

import type { ConcreteRequest } from 'relay-runtime';
export type usePopularFeedWithTimeGranularityStorageQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  timeGranularity?: string | null | undefined;
};
export type usePopularFeedWithTimeGranularityStorageQuery$data = {
  readonly popularFeed: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly contentProperties: {
          readonly latest: {
            readonly generatedBy: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly excerpt: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
          readonly createdDate: string | null | undefined;
          readonly ownedBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly name: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null | undefined;
          } | null | undefined;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly lastModifiedDate: string | null | undefined;
        };
        readonly space: {
          readonly alias: string | null | undefined;
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
        readonly version: {
          readonly friendlyWhen: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    }>;
    readonly pageInfo: {
      readonly endCursor: string;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
};
export type usePopularFeedWithTimeGranularityStorageQuery = {
  response: usePopularFeedWithTimeGranularityStorageQuery$data;
  variables: usePopularFeedWithTimeGranularityStorageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": "default",
  "kind": "LocalArgument",
  "name": "timeGranularity"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "timeGranularity",
    "variableName": "timeGranularity"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "subType"
},
v8 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v9 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v10 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 350
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:350)"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v13 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v11/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "KnownUser"
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "UnknownUser"
},
v20 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v21 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "friendlyWhen"
    }
  ]
},
v22 = {
  "concreteType": "FeedPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePopularFeedWithTimeGranularityStorageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  (v21/*: any*/)
                ]
              }
            ]
          },
          (v22/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePopularFeedWithTimeGranularityStorageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  (v21/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v22/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "39acb1147d229935866fe5c76d20c1bc",
    "id": "ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e",
    "metadata": {},
    "name": "usePopularFeedWithTimeGranularityStorageQuery",
    "operationKind": "query",
    "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\"){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "458c889823784393227130726e48009d";

export default node;
